<script>
import anchorme from 'anchorme'
import { mapState } from 'vuex'

export default {
  name: 'ClickableTitleMixin',
  data() {
    return {
      dataValue: '',
      clickable: false,
    }
  },
  computed: {
    ...mapState({
      showHyperLink: (state) => state.presentation.showHyperLink,
    }),
    titleRaw() {
      if (this.slide) {
        return this.slide.titleHTML ? this.slide.titleHTML : this.slide.title
      }
      if (this.slideActive) {
        return this.slideActive.titleHTML ? this.slideActive.titleHTML : this.slideActive.title
      }
      return ''
    },
  },
  watch: {
    showHyperLink(value, oldValue) {
      if (value !== oldValue) {
        this.handleText(this.titleRaw)
      }
    },
    titleRaw(value, oldValue) {
      if (value !== oldValue) {
        this.handleText(value)
      }
    },
  },
  mounted() {
    this.dataValue = this.titleRaw
    this.handleText(this.dataValue)
  },
  methods: {
    handleText(value) {
      if (!value) {
        value = ''
      }
      if (!this.showHyperLink) {
        if (typeof value === 'string') {
          let replaceValue = value.replace(/<a/g, '<p')
          replaceValue = replaceValue.replace(/text-hyper-link/g, '')
          this.dataValue = replaceValue
          this.clickable = false
        }
        return
      }
      if (value.indexOf('<a') === -1) {
        value = anchorme(value, {
          attributes: [
            {
              name: 'target',
              value: 'blank',
            },
            {
              name: 'class',
              value: 'text-hyper-link',
            },
          ],
        })
      }
      this.dataValue = value
      this.clickable = true
    },
  },
}
</script>

<style lang="scss" scoped>
.slide-title-style {
  &.clickable {
    pointer-events: inherit;
  }
}
</style>
